export const STATUS_DELIVERY = {
  0: {
    label: 'Produto Coletado',
    style: 'success-dark'
  },
  1: {
    label: 'Preparando Envio',
    style: 'error-dark'
  },
  2: {
    label: 'Em Trânsito',
    style: 'warning-light'
  },
  3: {
    label: 'Saiu para Entrega',
    style: 'success-dark'
  },
  4: {
    label: 'Falha na tentativa de Entrega',
    style: 'warning-light'
  },
  5: {
    label: 'Entregue',
    style: 'warning-light'
  },
  6: {
    label: 'Falha na Entrega',
    style: 'error-dark'
  },
  7: {
    label: 'Cancelado',
    style: 'warning-light'
  }
}
